import { OTA_VehRentalCore } from "./ota_vehrentalcore.model";
import { OTA_VehPref } from "./ota_vehpref.model";
import { OTA_DriverType } from "./ota_drivertype.model";
import { OTA_RateQualifier } from "./ota_ratequalifier.model";
import { OTA_SpecialEquipPref } from "./ota_specialequippref.model";
import { OTA_Customer } from "./ota_customer.model";

export class OTA_VehResRQCore {
    public status: string;
    public vehRentalCore = new OTA_VehRentalCore();
    public customer = new OTA_Customer();
    public vehPref = new OTA_VehPref();
    public driverType = new OTA_DriverType();
    public rateQualifier = new OTA_RateQualifier();
    public specialEquipPrefs = new Array<OTA_SpecialEquipPref>();
}
